import script from "./IntroApp.vue?vue&type=script&setup=true&lang=js"
export * from "./IntroApp.vue?vue&type=script&setup=true&lang=js"

import "./IntroApp.vue?vue&type=style&index=0&id=1f12f1fb&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f12f1fb"]])

export default __exports__